<script lang="ts">
    import { seedTrackingPropertiesFromQuery } from '$lib/Stores/seedTrackingProperties';

    import { onMount } from 'svelte';

    export let campaignId = '';

    // This happens only on refresh/initial load of the funnel
    // since the component only mounts once in layout
    onMount(() => {
        // The result mapping is no longer scaffolded here. It used to be written on every
        // load as a zeroed counter per result page, which put an entry on the visitor's
        // device before they had answered anything — or the cookie banner. The question
        // controllers create it on the first answer instead, which is the point at which it
        // starts doing anything, and `getResultPageId` already treats a missing mapping as
        // "no answers yet" and falls back to the first result page.

        // Seed placeholder values (text personalization + HTML block variable
        // interpolation) from URL query params. See seedTrackingPropertiesFromQuery
        // for why we no longer reset existing values here (FUN-3812).
        seedTrackingPropertiesFromQuery(campaignId);
    });
</script>
